import { ErrorPageV2 } from '@belong/ui-components';

export default ErrorPageV2;
